module.exports = __webpack_public_path__ + "img/274518574_530582111583895_5232748107945275191_n.a93eb7c0.jpg";